/* Knobs.co — Trade Professionals Application handler (task #8).
   ─────────────────────────────────────────────────────────────────
   Native /pages/trade application. On submit, pushes the applicant to
   Klaviyo (identify + a "Trade Application Received" event) using the
   onsite SDK already loaded by theme.liquid (company TiKVCi). No Admin
   token, no Shopify customer record — Klaviyo-only by design.

   Built 2026-05-31. Mirrors the wizard's Klaviyo pattern; the wizard's
   in-quiz trade branch fires the same event so segments/flows unify.
*/
(function () {
  'use strict';

  var root = document.getElementById('knobs-trade-app');
  if (!root) return;
  var form = root.querySelector('[data-trade-form]');
  var errEl = root.querySelector('[data-trade-error]');
  var successEl = root.querySelector('[data-trade-success]');
  var eventName = root.getAttribute('data-klaviyo-event') || 'Trade Application Received';
  if (!form) return;

  function klaviyoPush(tuple) {
    try { window.klaviyo = window.klaviyo || []; window.klaviyo.push(tuple); return true; }
    catch (e) { return false; }
  }
  function val(name) {
    var el = form.elements[name];
    return el ? (el.value || '').trim() : '';
  }
  function showError(msg) {
    if (!errEl) return;
    errEl.textContent = msg;
    errEl.classList.add('is-visible');
  }

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (errEl) { errEl.textContent = ''; errEl.classList.remove('is-visible'); }

    var first = val('first_name'), last = val('last_name'), email = val('email'), company = val('company'), type = val('business_type');
    if (!first || !last || !email || !company || !type) {
      return showError('Please fill in the required fields (name, email, company, business type).');
    }
    if (!EMAIL_RE.test(email)) {
      return showError('Please enter a valid email address.');
    }

    var consent = !!(form.elements['marketing_consent'] && form.elements['marketing_consent'].checked);

    var profile = {
      '$email': email,
      '$first_name': first,
      '$last_name': last,
      '$phone_number': val('phone'),
      '$organization': company,
      'trade_status': 'pending',
      'trade_business_type': type,
      'trade_website': val('website'),
      'trade_annual_volume': val('annual_volume'),
      'trade_project_types': val('project_types'),
      'trade_notes': val('message'),
      'trade_source': 'trade-application-page'
    };
    if (consent) profile.accepts_trade_marketing = true;

    klaviyoPush(['identify', profile]);
    klaviyoPush(['track', eventName, {
      company: company,
      business_type: type,
      annual_volume: val('annual_volume'),
      project_types: val('project_types'),
      website: val('website'),
      marketing_consent: consent,
      source: 'trade-application-page'
    }]);

    // Swap form → success state.
    if (successEl) {
      form.hidden = true;
      successEl.hidden = false;
      try { successEl.setAttribute('tabindex', '-1'); successEl.focus(); } catch (e) {}
      try { successEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    }
  });
})();
